import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/userservice/api/log/listLog',
    method: 'post',
    data: data
  });
}
export function fetchDetail(queryData) {
  return request({
    url: '/userservice/api/log/detail',
    method: 'get',
    params: queryData
  });
}